import maintenanceBg from './maintenance_bg.png';
import './App.css';

function App() {
  return (
    <div className="App" style={{ backgroundImage: `url(${maintenanceBg})` }}>
      <div className="overlay">
        <div className="content">
          <h1>Site Under Maintenance</h1>
          <p>We are currently working on making this site better. Please check back soon!</p>
          <div className="loader"></div>
        </div>
      </div>
    </div>
  );
}

export default App;
